<template>
  <div>
    <anamnesis
      :dataCrud.sync="localDataCrud"
      :dataCrud2.sync="localDataCrud2"
      v-bind="{
        ...schema,
        handleEventsCrud,
        handleEvents,
        handleEvents2,
        dialogTraceDiag,
        save,
        clickRowInfo,
        clickRowInfo2,
        remove,
        remove2,
        snackbar,
        overlay,
        overlayMessage,
        toggleOverlay,
        status,
      }"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Anamnesis from '@/components/includes/Anamnesis';

export default {
  name: 'DTxDiagTreatmentPage',
  components: { Anamnesis },

  data: () => ({
    overlay: false,
    overlayMessage: '',
    treatmentId: null,
    localDataCrud: [],
    localDataCrud2: [],
  }),

  watch: {
    dataCrud: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.localDataCrud = JSON.parse(JSON.stringify(newValue));
        }
      }
    },
    dataCrud2: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.localDataCrud2 = JSON.parse(JSON.stringify(newValue));
        }
      }
    }
  },

  computed: {
    ...mapGetters('anamDTxDiagTreatment', [
      'schema',
      'catDiagnosticICD10',
      'catDiagnosticICD11',
      'catDiagnosticDSM5',
      'dataCrud',
      'dataCrud2',
      'isNewRecord',
      'status',
    ]),
    ...mapGetters('anamPermissions', ['hasPermission']),
    ...mapGetters('notifications', ['snackbar']),
  },

  mounted() {
    this.loadData();
  },

  methods: {
    ...mapActions('anamDTxDiagTreatment', [
      'fetchSchema',
      'fetchRecords',
      'dialogTraceDiag',
      'createRecord',
      'updateRecord',
      'removeRecord',
    ]),
    ...mapActions('anamPermissions', ['sectionsHCPandRoute', 'checkPermission']),
    ...mapActions('notifications', ['triggerSnackbar']),

    async loadData() {
      try {
        await Promise.all([
          this.fetchSchema(),
          this.sectionsHCPandRoute(this.$route),
        ]);

        if (this.hasPermission) {
          await this.fetchRecords();
        } else {
          this.overlay = true;
          this.overlayMessage = 'No tiene acceso a esta sección. Solicite permisos.';
        }
      } catch (error) {
        this.handleDataError(error, 'Error al cargar datos.');
      }
    },

    toggleOverlay() {
      this.overlay = !this.overlay;
      if (!this.overlay && this.$route.name !== 'index') {
        this.$router.replace({ name: 'index' });
      }
    },

    handleEvents(val) {
      this.val = val;

      if (typeof val === 'object' && val !== null) {
        let nameProp1 = Object.hasOwn(val, 'diagnostic_manual');

        if (nameProp1) {
          this.diagnosticManual();
        }
      }
    },

    handleEvents2() {},

    clickRowInfo(clickItem) {
      this.diagnosticId = clickItem.diagnostic_id;
      this.clickItemDiag = clickItem;

      if (typeof clickItem === 'object' && clickItem !== null) {
        let nameProp4 = Object.hasOwn(clickItem, 'diagnostic_manual');

        if (nameProp4) {
          this.initDiagManual();
        }
      }
    },

    initDiagManual() {
      let diagManualId;
      !this.clickItemDiag.diagnostic_manual.diagnostic_manual_id
        ? (diagManualId = null)
        : (diagManualId = this.clickItemDiag.diagnostic_manual.diagnostic_manual_id);

      if (diagManualId === 1) {
        let chapterVal = '05';
        const catDiagnosticICD10Mental = this.catDiagnosticICD10.filter((item) =>
          item.diagnostic_icd_10_chapter.includes(chapterVal)
        );
        this.schema.formCrud.diagnostic.items = catDiagnosticICD10Mental;
      } else if (diagManualId === 2) {
        let chapterVal = '06';
        const catDiagnosticICD11Mental = this.catDiagnosticICD11.filter((item) =>
          item.diagnostic_icd_11_chapter.includes(chapterVal)
        );
        this.schema.formCrud.diagnostic.items = catDiagnosticICD11Mental;
      } else if (diagManualId === 3) {
        this.schema.formCrud.diagnostic.items = this.catDiagnosticDSM5;
      }
    },

    diagnosticManual() {
      let val = this.val;
      let manualId = val.diagnostic_manual_id;

      if (manualId === 1) {
        let chapterVal = '05';
        const catDiagnosticICD10Mental = this.catDiagnosticICD10.filter((item) =>
          item.diagnostic_icd_10_chapter.includes(chapterVal)
        );
        this.schema.formCrud.diagnostic.items = catDiagnosticICD10Mental;
      } else if (manualId === 2) {
        let chapterVal = '06';
        const catDiagnosticICD11Mental = this.catDiagnosticICD11.filter((item) =>
          item.diagnostic_icd_11_chapter.includes(chapterVal)
        );
        this.schema.formCrud.diagnostic.items = catDiagnosticICD11Mental;
      } else if (manualId === 3) {
        this.schema.formCrud.diagnostic.items = this.catDiagnosticDSM5;
      }
    },

    clickRowInfo2(clickItem) {
      this.treatmentId = clickItem.treatment_id;
    },

    async save() {
      try {
        const model = { dataCrud: this.localDataCrud, dataCrud2: this.localDataCrud2 };
        const action = this.isNewRecord ? 'createRecord' : 'updateRecord';
        await this[action]({ model });

        const message =
          this.status === 'success'
            ? this.sanitizeText(this.schema?.snackOk || 'Guardado correctamente.')
            : this.sanitizeText(this.schema?.snackError || 'Error al guardar.');

        this.showSnackbar(message, this.status === 'success' ? 'success' : 'error');

        this.fetchRecords();
      } catch (error) {
        console.error('Error al guardar:', error);
        this.showSnackbar(
          this.sanitizeText(this.schema?.snackError || 'Error inesperado.'),
          'error'
        );
      }
    },

    async remove() {
      if (!this.diagnosticId) {
        return this.showSnackbar('No hay un registro seleccionado.', 'warning');
      }

      try {
        await this.removeRecord({ id: this.diagnosticId, type: 1 });
        this.showSnackbar(
          this.sanitizeText(this.schema?.snackOkRemoved || 'Eliminado correctamente.'),
          'success'
        );      } catch (error) {
        console.error('Error al eliminar:', error);
        this.showSnackbar(this.sanitizeText(this.schema.snackError), 'error');
      }

      this.fetchRecords();
    },

    async remove2() {
      if (!this.treatmentId) {
        return this.showSnackbar('No hay un registro seleccionado.', 'warning');
      }

      try {
        await this.removeRecord({ id: this.treatmentId, type: 2 });
        this.showSnackbar(
          this.sanitizeText(this.schema?.snackOkRemoved || 'Eliminado correctamente.'),
          'success'
        );      } catch (error) {
        console.error('Error al eliminar:', error);
        this.showSnackbar(this.sanitizeText(this.schema.snackError), 'error');
      }

      this.fetchRecords();
    },

    handleEventsCrud() {},

    handleDataError(error, message) {
      console.error(message, error);
      this.showSnackbar(message, 'error');
    },

    showSnackbar(content, color) {
      this.triggerSnackbar({ content, color });
    },

    sanitizeText(text) {
      return text.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    },
  },
};
</script>
